// extracted by mini-css-extract-plugin
module.exports = {"item":"style-module--item--1zIQv","image":"style-module--image--3jOlA","title":"style-module--title--2ytn7"};